exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-9c580516]{opacity:1;transition:opacity .3s ease-out}.btn.saving[data-v-9c580516]{opacity:.7;cursor:progress}", ""]);

// exports
